// Module
var code = `<breadcrumbs></breadcrumbs>

<section id="watchlist" class="box">
  <sub-header header="'Watchlist'"></sub-header>
  <table class="watchlist__table table table-hover table-style"
         ng-if="\$ctrl.watchlist">
    <thead>
    <tr>
      <th class="no-column-header">No</th>
      <th>Name</th>
      <th>Customer type</th>
      <th>Type</th>
      <th></th>
    </tr>
    </thead>
    <tbody class="tbody">
    <tr ng-repeat="item in \$ctrl.watchlist">
      <td>
        {{ \$index+1+'.' }}
      </td>
      <td>{{ item.name }}</td>
      <td>{{ item.customerType | prettyEnum }}</td>
      <td>{{ item.watchlistType | prettyEnum }}</td>
      <td>
        <div class="buttons">
          <a class="watchlist__open-button btn btn-primary"
             ng-href="#!/admin/compliance/watchlist/{{item.id}}">
            Open
          </a>
          <button class="btn btn-danger"
                  command-access="DeleteWatchlist"
                  ng-click="\$ctrl.removeWatchlist(item.id)">
            Delete
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <div ng-if="!\$ctrl.watchlist || !\$ctrl.watchlist.length"
       class="centered-gray-information-message">
    <span>No watchlist found.</span>
  </div>

  <div class="buttons">
    <button class="btn btn-warning"
            ng-click="\$ctrl.goBack()">
      Back
    </button>
    <a class="sub-header__create-button btn btn-primary"
       ng-href="#!/admin/compliance/watchlist/create">
      Create new
    </a>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/watchlist/watchlist.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;